import {Component, inject, OnInit} from '@angular/core';
import {
    FirstTimeUserExperienceService
} from "fuse-core/components/first-time-user-experience/first-time-user-experience.service";
import {
    FirstTimeUserExperienceStepOneComponent
} from "fuse-core/components/first-time-user-experience/fuse-first-time-user-experience-step-one/first-time-user-experience-step-one.component";
import {mapTo, mergeMap, take, tap} from "rxjs/operators";
import {of} from "rxjs/internal/observable/of";
import {combineLatest, Observable, ReplaySubject} from 'rxjs';
import {
    FirstTimeUserExperienceStepTwoComponent
} from "fuse-core/components/first-time-user-experience/first-time-user-experience-step-two/first-time-user-experience-step-two.component";
import {DataEntity} from "octopus-connect";
import {UserProgression} from "fuse-core/components/home-page/home-page.component";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialogRef} from "@angular/material/dialog";

export interface DataStepOne {
    educationalLevels: DataEntity[],
    educationalLevelStarter: DataEntity
}
@Component({
  selector: 'app-first-time-user-experience',
  standalone: true,
    imports: [
        FirstTimeUserExperienceStepOneComponent,
        FirstTimeUserExperienceStepTwoComponent
    ],
  templateUrl: './first-time-user-experience.component.html',
  styleUrl: './first-time-user-experience.component.scss'
})
export class FirstTimeUserExperienceComponent implements OnInit {
    educationalLevelStarter: DataEntity;
    ftuxService = inject(FirstTimeUserExperienceService);
    router = inject(Router);
    route = inject(ActivatedRoute);
    dialogRef = inject(MatDialogRef<FirstTimeUserExperienceComponent>);
    stepOne = false;
    stepTwo = false;
    educationalLevels$ = this.ftuxService.getEducationalLevels().pipe(
        take(1),
        mergeMap(educationalLevels => of(educationalLevels.entities.slice().filter((educationalLevel: DataEntity) => !educationalLevel.get('label').toLowerCase().includes('cycle')) )),
    );
    concepts$: Observable<DataEntity[]> = this.ftuxService.loadConcepts().pipe(
        take(1),
        mergeMap(concepts => of(concepts.slice())),
    );
    concepts: DataEntity[] = [];
    groups: DataEntity[] = [];

    ngOnInit() {
        // Initialize the first step
        this.concepts$.pipe(
            tap((concepts: DataEntity[]) => this.concepts = concepts),
        ).subscribe()
        this.stepOne = true;
    }
    onNextStepOne(data: DataStepOne) {
        this.educationalLevelStarter = data.educationalLevelStarter;
        const groups$ = data.educationalLevels.map((educationalLevel: DataEntity) => {
            return this.ftuxService.createGroup({
                workgroupname: 'Mon groupe de ' + educationalLevel.get('label'),
                groupname: 'Ma classe de ' + educationalLevel.get('label'),
                archived: false,
                level: educationalLevel.get('label'),
                schoolyear_term: '',
                parents: [],
                projects: []
            });
        });
        combineLatest(groups$).pipe(
            tap((groups: DataEntity[]) => {
                this.groups = groups;
                this.stepTwo = true;
                this.stepOne = false;
            })
        ).subscribe();
    }
    onNextStepTwo(mode: string) {
        if (mode === 'open-progression') {
            this.loadUserProgression(this.educationalLevelStarter.id.toString())
                .pipe(
                    tap((userProgression) => {
                        const sequences = userProgression.chapters[0].sequences;
                        this.router.navigate(['lessons', sequences[0], 'page']);
                        this.dialogRef.close();
                    })
                )
                .subscribe()
        }
        if (mode === 'open-lessons-search') {
            this.ftuxService.getCollectiveUsage().pipe(
                tap((collectiveUsage) => {
                    this.router.navigate(['lessons', 'list', 'search'], {queryParams: {usage: collectiveUsage.id, educationalLevel: this.educationalLevelStarter.id}});
                    this.onClose();
                }),
            ).subscribe();
        }
    }
    onClose() {
        this.dialogRef.close();
    }

    private loadUserProgression(educational_level: string): Observable<UserProgression> {
        const userProgressFilter = {
            educationalLevel: educational_level,
            concept: this.ftuxService.userData?.get('config')?.concept?.toString() || this.concepts[0].id.toString(),
        };
        return this.ftuxService.loadUserProgression(userProgressFilter).pipe(take(1));
    }
}
